import type { EnumFilterOption } from './columnSearchProps'

export const DOC_TYPE_FILTER_OPTIONS: EnumFilterOption[] = [
  { label: 'Allot(ALT)', value: 'ALT' },
  { label: 'Dehire(DHR)', value: 'DHR' },
  { label: 'Goods Receipt Note(GRN)', value: 'GRN' },
  { label: 'Relocation(RELO)', value: 'REL_OUT' },
  { label: 'Trading Sale(TS)', value: 'TS' },
  { label: 'job_work', value: 'job_work', disabled: true },
  { label: 'trading_cell', value: 'trading_cell', disabled: true },
]

export const STATUS_FILTER_OPTIONS: EnumFilterOption[] = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Rejected', value: 'Rejected' },
]
